<bn-loading-overlay></bn-loading-overlay>

<div class="container">
  <div class="row">
    <div class="col">
      <h3>Envio de documento de acompanhamento</h3>
    </div>

    <div class="col-auto">
      <button class="btn btn-primary" type="button" [routerLink]="['/acompanhamento-documento-depr/pesquisa']">Voltar</button>
      <button
        class="btn btn-primary"
        type="button"
        [hidden]="acompanhamentoDetalhe"
        [disabled]="disabledBtnEnviar"
        (click)="enviar()"
      >
        Enviar
      </button>
      <div ngbDropdown placement="bottom-right" class="btn-group ms-1" keyboard-nav *ngIf="podeAvaliar()">
        <button id="btn.Actions" type="button" [disabled]="encaminhadoAde" class="btn btn-warning custom-button"
          ngbDropdownToggle>
          <input type="checkbox" checked onclick="return false;" /> Ações
        </button>

        <ul class="dropdown-menu" ngbDropdownMenu role="menu" aria-labelledby="simple-btn-keyboard-nav">
          <li role="menuitem" class="dropdown-item link-pointer" container="body" placement="left">
            <a id="btn.Actions.documentoValidado" class="d-block" (click)="prepararValidar()">
              <span> Documento Validado </span>
            </a>
          </li>

          <li role="menuitem" class="dropdown-item link-pointer" container="body" placement="left">
            <a id="btn.Actions.SolicitarInclucaoNaPauta" class="d-block" (click)="prepararRejeitar()">
              <span> Documento Rejeitado </span>
            </a>
          </li>
        </ul>
      </div>
    </div>
  </div>

  <br />
  <div class="row">
    <div class="col-12">
      <app-acompanhamento-depr-stepper
        [acompanhamentoDetalhe]="acompanhamentoDetalhe"
        [acompanhamentoDepr]="acompanhamentoDepr"
      ></app-acompanhamento-depr-stepper>

      <ul ngbNav #nav="ngbNav" class="col nav-tabs">
        <li title="Documento" [ngbNavItem]>
          <a ngbNavLink>Documento</a>
          <ng-template ngbNavContent>
            <app-aba-documento
              (updateStatusDisabledBtnEnviar)="updateStatusDisabledBtnEnviar($event)"
              [acompanhamentoDetalhe]="acompanhamentoDetalhe"
              [acompanhamentoDepr]="acompanhamentoDepr"
              [clickEnviar]="clickEnviar"
            ></app-aba-documento
          ></ng-template>
        </li>

        <li title="Histórico" *ngIf="acompanhamentoDetalhe" [ngbNavItem]>
          <a ngbNavLink>Histórico</a>
          <ng-template ngbNavContent>
            <app-aba-historico
              [acompanhamentoDepr]="acompanhamentoDepr">
            </app-aba-historico> </ng-template>
        </li>
      </ul>

      <div [ngbNavOutlet]="nav" class="mt-2"></div>
    </div>
  </div>
</div>

<ng-template #msgTemplateRejeitar>
  <span>Inserir justificativa de rejeição do documento: </span>
  <br />
  <textarea class="form-control" name="motivoEstado" id="motivoEstado" [(ngModel)]="acompanhamentoDepr.motivoEstado"
    required minlength="2" maxlength="1000" rows="3"></textarea>
  <br />
</ng-template>
<ng-template #botoesPersonalizadosRejeitar>
  <button class="btn btn-md btn-success" (click)="rejeitar()">
    Confirmar
  </button>
  <button class="btn btn-md btn-primary" (click)="dismissModal()">
    Voltar
  </button>
</ng-template>

<ng-template #msgTemplateValidar>
  <span>Inserir comentários de validação do documento:</span>
  <br />
  <textarea class="form-control" name="motivoEstado" id="motivoEstado" [(ngModel)]="acompanhamentoDepr.motivoEstado"
            required minlength="2" maxlength="1000" rows="3"></textarea>
  <br />
</ng-template>
<ng-template #botoesPersonalizadosValidar>
  <button class="btn btn-md btn-success" (click)="validar()">
    Confirmar
  </button>
  <button class="btn btn-md btn-primary" (click)="dismissModal()">
    Voltar
  </button>
</ng-template>
